import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import { toast } from 'react-toastify';

import Form, { ButtonItem, GroupItem, IButtonItemProps, Label, RequiredRule, SimpleItem } from 'devextreme-react/form';
import ValidationGroup from 'devextreme-react/validation-group';

import { useAuth } from 'context/auth';

import { useLazyGetContractorDetailInfoQuery } from 'bus/contractor/services/services';
import { useChangeContractorIndividualMutation } from 'bus/contractorIndividual/services/services';
import { ContractorIndividualItem } from 'bus/contractorIndividual/types';
import { useGetContractorObjectLocationsQuery } from 'bus/contractorObject/services';

const initialForm = {
  id: null,
  contractorType: 0,
  name: '',
  phone: '',
  email: '',
  //fault: undefined,
  comment: '',
  isProvider: false,
  isDeleted: false,
  locationType: 0,
};

const IndividualForm: FC = () => {
  let { id } = useParams<{ id: string }>();
  const { getClaims }: any = useAuth();
  let createCatalogGroupRef = useRef<any>(null);

  const [changeContractorIndividual] = useChangeContractorIndividualMutation();
  const { data: contractorObjectLocations } = useGetContractorObjectLocationsQuery();

  const [form, setForm] = useState<ContractorIndividualItem>({ ...initialForm });

  const [getContractorDetailInfo] = useLazyGetContractorDetailInfoQuery();

  const getData = useCallback(async () => {
    const data = await getContractorDetailInfo({ id }).unwrap();
    setForm((prev) => ({ ...prev, ...data }));
  }, [getContractorDetailInfo, id]);

  useEffect(() => {
    getData();
  }, [getData]);

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();
    if (createCatalogGroupRef.current.instance.validate().isValid) {
      await changeContractorIndividual({ ...form });
      toast.success('Успешно сохранено', {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  const isCanEditIndividualContractor = !getClaims(['CanEditIndividualContractor']);

  const buttonOptions: IButtonItemProps['buttonOptions'] = {
    text: 'Сохранить',
    type: 'success',
    useSubmitBehavior: true,
    disabled: isCanEditIndividualContractor,
  };

  return (
    <div className="pa-2">
      <form onSubmit={handleSubmit}>
        <ValidationGroup>
          <Form formData={form} ref={createCatalogGroupRef} readOnly={isCanEditIndividualContractor}>
            <GroupItem cssClass="first-group" colCount={4}>
              <SimpleItem dataField="name" colSpan={4}>
                <Label text="Имя" />
                <RequiredRule message="Заполните поле Имя" />
              </SimpleItem>

              <SimpleItem dataField="phone" colSpan={2} editorOptions={{ mask: '+7 (000) 000-00-00' }}>
                <Label text="Телефон" />
                <RequiredRule message="Заполните поле Телефон" />
              </SimpleItem>

              <SimpleItem dataField="email" colSpan={2}>
                <Label text="email" />
              </SimpleItem>

              <SimpleItem dataField="comment" colSpan={4} editorType="dxTextArea">
                <Label text="Комментарий" />
              </SimpleItem>

              <SimpleItem
                dataField="locationType"
                colSpan={2}
                editorType="dxSelectBox"
                editorOptions={{
                  items: contractorObjectLocations,
                  displayExpr: 'name',
                  valueExpr: 'id',
                }}
              >
                <Label text="Местность" />
                <RequiredRule message="Заполните поле Местность" />
              </SimpleItem>

              <SimpleItem
                dataField="isProvider"
                colSpan={4}
                editorType="dxCheckBox"
                editorOptions={{ text: 'Поставщик' }}
              >
                <Label text=" " />
              </SimpleItem>
            </GroupItem>

            <ButtonItem horizontalAlignment="left" buttonOptions={buttonOptions} />
          </Form>
        </ValidationGroup>
      </form>
    </div>
  );
};

export default IndividualForm;
